import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/sound/play.png'
import _imports_1 from '@/assets/sound/pause.png'
import _imports_2 from '@/assets/aivoice/pic_kongyinpin.svg'
import _imports_3 from '@/assets/svg/loding2.gif'


const _hoisted_1 = { class: "initBox" }
const _hoisted_2 = { class: "initBoxInner" }
const _hoisted_3 = { class: "initBoxTop" }
const _hoisted_4 = { class: "initBoxInnerTitle" }
const _hoisted_5 = { class: "initBoxInnerTitle" }
const _hoisted_6 = { class: "initTab" }
const _hoisted_7 = { class: "tabList" }
const _hoisted_8 = { class: "tabMain" }
const _hoisted_9 = {
  key: 0,
  class: "tabMainCommon"
}
const _hoisted_10 = {
  key: 1,
  class: "tabMainCommon"
}
const _hoisted_11 = { class: "el-upload__text" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "tabBtm" }
const _hoisted_14 = { class: "tabBtmRole" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "tabBtmRoleTitle" }
const _hoisted_17 = { class: "tabBtmBtn" }
const _hoisted_18 = { class: "soundHall" }
const _hoisted_19 = {
  key: 0,
  class: "soundHallList"
}
const _hoisted_20 = { class: "timbreOneImg" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 0,
  class: "playBtn"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 1,
  class: "playBtn"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "timbreOneName" }
const _hoisted_27 = { class: "timbreOneTitle" }
const _hoisted_28 = { class: "timbreOneBtn" }
const _hoisted_29 = { class: "timbreOneBtnInner" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 1,
  class: "noDataPage"
}
const _hoisted_34 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_35 = { class: "piecedelBox" }
const _hoisted_36 = { class: "pieceBoxmask" }

import { ref, onMounted,getCurrentInstance,onUnmounted,watch } from 'vue'
// 引入模块
import textEdit from "../commonPage/textEdit.vue"
//接口引入
import depotApi from "@/api/sound/depot.ts";
// 引入音色市场模块
import timbreMarket from "../commonPage/timbreMarket.vue"
import changeSoundApi from "@/api/sound/changeSound.ts";
import builtSoundApi from "@/api/sound/soundBuilt.ts";
import {
    Setting,
    UploadFilled ,
    
} from "@element-plus/icons-vue";
import { useRouter, useRoute } from 'vue-router';
import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { push, currentRoute } = useRouter();
const token = Auth.getToken();
let { proxy } = getCurrentInstance();
// 默认参数
const isChange=ref(false)
const showRoleOne=ref('')//默认变声角色
const showlodaing=ref(false)//等待状态
// 切换tab
const tabStyle={
    'border': '1px solid transparent',
    'background-clip': 'padding-box, border-box',
    'background-origin': 'padding-box, border-box',
    'background-image': 'linear-gradient(to right, #000, #000), linear-gradient(90deg, rgba(23, 176, 103, 1), RGBA(32, 35, 37, 1))',
    // 'background': 'linear-gradient(0deg, #17B067 0%, #99EA69 100%)',
    // '-webkit-background-clip': 'text',
    // '-webkit-text-fill-color': 'transparent',
    // 'color': 'transparent', /* 对于非WebKit浏览器 */
    'height':'4rem',
    'lineHeight':'4rem',
}
// 音色市场
const marketShow=ref(false)
const fileMain=ref()//上传文件
const fileName=ref('')
const datalist=ref([])//音色列表
const pageNum=ref(1)//当前页数
const pageSize=ref(500)//每页条数
const urlListening=ref('')//试听地址
const audioRef=ref()
onMounted(()=>{
    getPublic()
    getMarkList()
})
onUnmounted(()=>{
    audioRef.value?.pause()
})
// 切换音色
const openMarket=()=>{
    marketShow.value=true
}
// 获取角色，默认选择公开角色第一个
const getPublic=()=>{
    depotApi.getFinishList(1, 5,100,1).then((res) => {
        // roleList.value = res.rows;
        console.log(res.rows[0])
        showRoleOne.value=res.rows[0]
        
    });
}
// 获取角色，选择变声公开角色第一个
const getPublicChange=()=>{
    depotApi.getListFinishChange(1, 5,1,1,100).then((res) => {
        // roleList.value = res.rows;
        console.log(res.rows[0])
        showRoleOne.value=res.rows[0]
        
    });
}
watch(isChange,(n,o)=>{
    if(n){
        getPublicChange()
    }else{
        getPublic()
    }
})
// 
const text=ref('')
const language=ref('0')
const reListData=(data:string)=>{
    console.log(data[0])
    text.value=data[0]
    language.value=data[1]
}
const recognition=(data:string)=>{
    showRoleOne.value=JSON.parse(data)
}
// 提交--立即生成
const initChangeData={
    volume: 100,
    gainVc: 0,
    slow: 100,
    indexrate: 0.5,
    protect: 0.5,
    duration: 0,
    soundField:'0',
}
const initcreat={
    mode:'1'
}
const sendSound=()=>{
    console.log(isChange.value)
    console.log(showRoleOne.value)
    if(showRoleOne.value==undefined || showRoleOne.value.roleId==undefined){
        return
    }
    if(isChange.value){
        console.log('变声')
        changeSoundApi.addChange(showRoleOne.value.roleId,upFileId.value,initChangeData,0).then(res=>{
            console.log(res)
            ElMessage({
                type: 'success',
                message: '提交完成' ,
            })
            let obj={
                avatar:showRoleOne.value.avatar,
                intro:showRoleOne.value.intro,
                roleId:showRoleOne.value.roleId,
                name:showRoleOne.value.name,
            }
            localStorage.setItem('roleSound',JSON.stringify(obj))
            push('/index/soundChange')
        })
    }else{
        console.log('生成语音')
        builtSoundApi.addSoundBuilt(showRoleOne.value.roleId,language.value,initcreat,0,text.value).then(res=>{
            console.log(res)
            ElMessage({
                type: 'success',
                message: '提交完成' ,
            })
            let obj={
                avatar:showRoleOne.value.avatar,
                intro:showRoleOne.value.intro,
                roleId:showRoleOne.value.roleId,
                name:showRoleOne.value.name,
            }
            localStorage.setItem('roleSound',JSON.stringify(obj))
            push('/index/soundGeneration')
        })
    }
}
// 生成语音
const creatSound=(data:any)=>{
    console.log('生成语音')
    localStorage.setItem('roleSound',JSON.stringify(data))
    push('/index/soundGeneration')
}
// 变声
const changeSound=(data:any)=>{
    console.log('变声')
    console.log(data)
    if(data.voiceChangeEnable==0){
        return
    }else{
        localStorage.setItem('roleSound',JSON.stringify(data))
        push('/index/soundChange')
    }
}
// 上传文件
const upFileId=ref('')
const upFile=(file:any)=>{
    console.log(file.raw.size)
    const isLtM = file.raw.size / 1024 / 1024;
    
  if ( isLtM > 100) {
    ElMessage.error("请上传100M以内的文件!");
    return false
  }
  fileName.value=file.name
  fileMain.value=file.raw
  showlodaing.value=true
  const formDatas = new FormData();
    formDatas.append('file',file.raw);
    formDatas.append('businessType','voiceChange');
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            
            if (data.code == 200) {
                console.log(data)
                upFileId.value=data.data.fileId
                fileName.value=file.name
                showlodaing.value=false
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
            

        })
}
// 获取音色市场列表
const getMarkList=()=>{
    depotApi.getList(pageNum.value, pageSize.value,1).then((res) => {
        // roleList.value = res.rows;
        console.log(res.rows[0])
        
        res.rows.forEach((item:any )=> {
            item.isPlaying=false
            datalist.value.push(item)
        });
      
    });
}
// 播放
const playIndex=ref(-1)
const selData=ref()
const toPlay =(data:any,index:number)=>{
    console.log(index)
    playIndex.value=index
    datalist.value.forEach((item:any )=> {
        item.isPlaying=false
    });
    if(selData.value == null || data.roleId!=selData.value.roleId){
        selData.value=data
        // showlodaing.value=true
        if(data.demoAudio==undefined){
            depotApi.roleListening(datalist.value[index].roleId).then(res=>{
                console.log(res)
                if(res.code==200){
                    urlListening.value=res.msg
                    setTimeout(()=>{
                        showlodaing.value=false
                        datalist.value[index].isPlaying=true
                        audioRef.value?.play()
                    },100)
                }
                
            }).catch(err=>{
                showlodaing.value=false
                
            })
        }else{
            urlListening.value=data.demoAudio
            setTimeout(()=>{
                showlodaing.value=false
                datalist.value[index].isPlaying=true
                audioRef.value?.play()
            },100)
        }
        
    }else {
            showlodaing.value=false
            datalist.value[index].isPlaying=true
            audioRef.value?.play()
           
            
        }
   
}
// 暂停
const topause=(index:number)=>{
    datalist.value[index].isPlaying=false
    audioRef.value?.pause()
}
const updateCurrentTime = () => {
    console.log('111111')
    
    datalist.value[playIndex.value].isPlaying=false
    audioRef.value?.pause()
 
}
// 克隆试听
// const funListening=()=>{
    
//     if(urlListening.value!=''){
//         isPlay.value=true
//         audioRef.value?.play()
//         return
//     }
//     showlodaing.value=true
//     depotApi.tryListening(upUrl.value,demoText.value).then(res=>{
//         console.log(res)
//         if(res.code==200){
//             urlListening.value=res.msg
//             showlodaing.value=false
//             isPlay.value=true
//             audioRef.value?.play()
//         }
        
//     }).catch(err=>{
//         showlodaing.value=false
        
//     })
// }
// 暂停播放
// const audioStop=()=>{
//     isPlay.value=false
//     audioRef.value?.pause()
// }
// const updateCurrentTime = () => {
//     console.log('111111')
//         isPlay.value=false
//         audioRef.value?.pause()
 
// }

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, { height: "100%" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("div", _hoisted_4, _cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "titleTop" }, "写段文字，一秒生成影视级真人语音", -1),
              _createElementVNode("span", { class: "titleBtm" }, "导演做配音、演员补台词、UP 主剪片、主播旁白，都用它", -1)
            ]), 512), [
              [_vShow, !isChange.value]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_5, _cache[4] || (_cache[4] = [
              _createElementVNode("span", { class: "titleTop" }, "你说一句话，瞬间化身御姐、萝莉、大叔、甚至明星嗓", -1),
              _createElementVNode("span", { class: "titleBtm" }, "影视配音、角色变声、直播演绎、游戏开麦、全都靠它", -1)
            ]), 512), [
              [_vShow, isChange.value]
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "tabListOne",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isChange.value=false), ["stop"])),
                  style: _normalizeStyle(isChange.value==false?tabStyle:'')
                }, "幻音TTS", 4),
                _createElementVNode("div", {
                  class: "tabListOne",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isChange.value=true), ["stop"])),
                  style: _normalizeStyle(isChange.value==true?tabStyle:'')
                }, "幻音VC", 4)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (!isChange.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(textEdit, { onReListData: reListData })
                    ]))
                  : _createCommentVNode("", true),
                (isChange.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_el_upload, {
                        class: "upload-demo",
                        drag: "",
                        multiple: "",
                        accept: ".mp3,.wav",
                        onChange: upFile,
                        "auto-upload": false,
                        "show-file-list": false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_el_icon, {
                              color: "#fff",
                              size: "36"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(UploadFilled))
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createElementVNode("div", _hoisted_12, _cache[5] || (_cache[5] = [
                              _createElementVNode("span", null, "点击或拖拽 视频文件 到这里上传", -1),
                              _createElementVNode("span", null, "*仅支持mp3、wav格式 *最大支持100M文件上传", -1)
                            ]), 512), [
                              [_vShow, fileName.value=='']
                            ]),
                            _withDirectives(_createElementVNode("div", null, _toDisplayString(fileName.value), 513), [
                              [_vShow, fileName.value!='']
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: _unref(proxy).getimgUrlVoice + showRoleOne.value.avatar
                  }, null, 8, _hoisted_15),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(showRoleOne.value.name), 1),
                  _createVNode(_component_el_icon, {
                    onClick: _withModifiers(openMarket, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Setting))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: "sendBtn",
                    onClick: _withModifiers(sendSound, ["stop"])
                  }, " 立即提交 ")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "soundHallTitle" }, " 音色展厅 ", -1)),
            (datalist.value?.length>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datalist.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "timbreOne",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("img", {
                          src: _unref(proxy).getimgUrlVoice+item.avatar,
                          alt: "",
                          class: "picOne"
                        }, null, 8, _hoisted_21),
                        (!item.isPlaying)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: "",
                                onClick: _withModifiers(($event: any) => (toPlay(item,index)), ["stop"])
                              }, null, 8, _hoisted_23)
                            ]))
                          : _createCommentVNode("", true),
                        (item.isPlaying)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "",
                                onClick: _withModifiers(($event: any) => (topause(index)), ["stop"])
                              }, null, 8, _hoisted_25)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_26, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_27, _toDisplayString(item.intro), 1),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", {
                            class: "changeBtn",
                            onClick: _withModifiers(($event: any) => (creatSound(item)), ["stop"])
                          }, "生成语音", 8, _hoisted_30),
                          _createElementVNode("span", {
                            class: "soundBtn",
                            onClick: _withModifiers(($event: any) => (changeSound(item)), ["stop"]),
                            style: _normalizeStyle(item.voiceChangeEnable==0?{'background':'#565658'}:'')
                          }, "变声", 12, _hoisted_31)
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("audio", {
                    src: _unref(proxy).getimgUrlVoice + '/' + urlListening.value,
                    controls: "",
                    ref_key: "audioRef",
                    ref: audioRef,
                    onEnded: updateCurrentTime,
                    style: {"display":"none"}
                  }, null, 40, _hoisted_32)
                ]))
              : _createCommentVNode("", true),
            (datalist.value?.length==0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "imgBox" }, [
                    _createElementVNode("img", { src: _imports_2 }),
                    _createElementVNode("div", null, "暂无数据")
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      (marketShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(timbreMarket, {
                isChange: isChange.value,
                onCloseThis: _cache[2] || (_cache[2] = ($event: any) => (marketShow.value = false)),
                onRecognition: recognition
              }, null, 8, ["isChange"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_36, _cache[8] || (_cache[8] = [
      _createElementVNode("div", { class: "maskBox" }, [
        _createElementVNode("img", {
          src: _imports_3,
          style: {"width":"90px","height":"90px"}
        }),
        _createElementVNode("span", null, "正在加载资源中，请稍候...")
      ], -1)
    ]), 512), [
      [_vShow, showlodaing.value]
    ])
  ]))
}
}

})